<template>
  <div>
    <mds-page-shell
      :logo="getProductLogo()"
      :logo-responsive="getProductLogo()"
      logo-href="/"
      logo-alt="Back to home page"
    >
      <div class="billing-address-main">
        <div class="billingaddress-registration-form-billing-address">
          <div class="billingaddress-registration-form-billing-address-container">
            <div class="billing-address-form-title">
              <div v-if="!isValidAddress" class="billing-address-invalid">
                <mds-alert
                  variation="error"
                  title="We were unable to verify your billing details. Please review the information below for errors."
                  tinted
                  @mds-alert-dismissed="CloseAlertBox"
                >
                  If you need assistance, contact support at +1 312 424-4288 (or +1 800
                  957-6021 if calling from outside the US).
                </mds-alert>
              </div>

              <div v-if="isValidAddress">
                <h1 class="billing-address-page-title">Billing information</h1>
              </div>
            </div>
            <div class="billingaddress-loader" v-if="isLoading">
              <mds-loader aria-label="Medium Loader" size="medium"></mds-loader>
            </div>
            <div>
              <div class="billing-address-form-fields">
                <mds-select
                  v-model.trim="country"
                  class="input-tab"
                  size="large"
                  label="Country"
                  type="text"
                  @change="onChangeCountry"
                  required
                  :error="CountryError"
                >
                  <option
                    v-for="country in liststripeCountry"
                    v-bind:key="country.CountryCode"
                    :value="country.CountryCode"
                  >
                    {{ country.Country }}
                  </option>
                </mds-select>
                <span class="FormsError" v-if="CountryError"
                  >Please select country from dropdown</span
                >
                <br />
                <mds-input
                  v-model.trim="address"
                  type="text"
                  size="large"
                  :error="addressError"
                  label="Address"
                  required
                ></mds-input>
                <span class="FormsError" v-if="addressError"
                  >Please enter Address</span
                >

                <br />
                <mds-input
                  v-model.trim="city"
                  :error="cityError"
                  size="large"
                  label="City"
                  required
                ></mds-input>
                <span class="FormsError" v-if="cityError">Please enter City</span>
                <br />
                <div v-if="isResponsive">
                  <div v-if="isStateUSA">
                    <mds-select
                      v-if="isStateUSA"
                      v-model.trim="USAstate"
                      :label="stateLable"
                      size="large"
                      required
                      :error="stateError"
                      placeholder="Select..."
                    >
                      <option
                        v-for="USAstate in listUSAState"
                        :key="USAstate.StateName"
                        :value="USAstate.StateAbbr"
                      >
                        {{ USAstate.StateName }}
                      </option>
                    </mds-select>
                  </div>
                  <span class="FormsError" v-if="stateError"
                    >Please select state from dropdown</span
                  >
                  <div v-if="isStateCanada">
                    <mds-select
                      v-if="isStateCanada"
                      v-model.trim="Canadastate"
                      :label="stateLable"
                      size="large"
                      placeholder="Select..."
                    >
                      <option
                        v-for="Canadastate in listCanadaState"
                        :key="Canadastate.StateName"
                        :value="Canadastate.StateAbbr"
                      >
                        {{ Canadastate.StateName }}
                      </option>
                    </mds-select>
                  </div>

                  <div v-if="isNotUSACanadaState">
                    <mds-input
                      v-if="isNotUSACanadaState"
                      v-model.trim="stateprovince"
                      :label="stateLable"
                      size="large"
                    ></mds-input>
                  </div>

                  <br />
                  <mds-input
                    v-model.trim="zipcode"
                    label="Zip Code"
                    size="large"
                    :required="isZipCodeRequired"
                    :error="zipcodeError"
                  ></mds-input>

                  <span class="FormsError" v-if="zipcodeError">{{
                    zipcodeErrorMessage
                  }}</span>
                  <br />
                  <mds-select
                    label="Phone Type"
                    size="large"
                    required
                    v-model.trim="phonetype"
                    @change="changePhoneType()"
                  >
                    <option
                      v-for="phonetype in listphoneType"
                      v-bind:key="phonetype.text"
                      :value="phonetype.text"
                    >
                      {{ phonetype.text }}
                    </option>
                  </mds-select>
                  <br />
                  <mds-input
                    label="Phone Number"
                    size="large"
                    type="text"
                    required
                    v-model.trim="phonenumber"
                    :error="phonenumberError"
                    maxlength="20"
                  ></mds-input>
                  <span class="FormsError" v-if="phonenumberError">{{
                    phoneErrorMessage
                  }}</span>
                </div>
              </div>
              <div v-if="!isResponsive">
                <div class="horizonatal-fieldset">
                  <div class="fieldset-first">
                    <div v-if="isStateUSA">
                      <mds-select
                        v-model.trim="USAstate"
                        :label="stateLable"
                        size="large"
                        required
                        :error="stateError"
                        placeholder="Select..."
                      >
                        <option
                          v-for="USAstate in listUSAState"
                          :key="USAstate.StateName"
                          :value="USAstate.StateAbbr"
                        >
                          {{ USAstate.StateName }}
                        </option>
                      </mds-select>
                    </div>
                    <span class="FormsError" v-if="stateError"
                      >Please select state from dropdown</span
                    >
                    <div v-if="isStateCanada">
                      <mds-select
                        v-if="isStateCanada"
                        v-model.trim="Canadastate"
                        :label="stateLable"
                        size="large"
                        placeholder="Select..."
                      >
                        <option
                          v-for="Canadastate in listCanadaState"
                          :key="Canadastate.StateName"
                          :value="Canadastate.StateAbbr"
                        >
                          {{ Canadastate.StateName }}
                        </option>
                      </mds-select>
                    </div>
                    <div v-if="isNotUSACanadaState">
                      <mds-input
                        v-if="isNotUSACanadaState"
                        v-model.trim="stateprovince"
                        :label="stateLable"
                        size="large"
                      ></mds-input>
                    </div>
                  </div>
                  <div class="fieldset-second">
                    <mds-input
                      v-model.trim="zipcode"
                      :label="zipLable"
                      size="large"
                      :required="isZipCodeRequired"
                      :error="zipcodeError"
                    ></mds-input>
                    <span class="FormsError" v-if="zipcodeError">{{
                      zipcodeErrorMessage
                    }}</span>
                  </div>
                </div>
                <br />
                <div class="horizonatal-fieldset">
                  <div class="fieldset-first">
                    <mds-select
                      label="Phone Type"
                      size="large"
                      required
                      v-model.trim="phonetype"
                      @change="changePhoneType()"
                    >
                      <option
                        v-for="phonetype in listphoneType"
                        v-bind:key="phonetype.text"
                        :value="phonetype.text"
                      >
                        {{ phonetype.text }}
                      </option>
                    </mds-select>
                  </div>
                  <div class="fieldset-second">
                    <mds-input
                      label="Phone Number"
                      size="large"
                      type="text"
                      required
                      v-model.trim="phonenumber"
                      :error="phonenumberError"
                      maxlength="20"
                    ></mds-input>
                    <span class="FormsError" v-if="phonenumberError">{{
                      phoneErrorMessage
                    }}</span>
                  </div>
                </div>
              </div>
              <div v-if="isMobileChecked">
                <div class="billing-address-checkboxes">
                  <mds-checkbox
                    size="small"
                    value="accept"
                    v-model="mobileAlerts"
                    >By checking the box and submitting this form, I consent to receive
                    phone calls for special offers reserved for Morningstar customers at
                    any number I provide here using automated technology. I understand my
                    consent is not required in order to receive products or services from
                    Morningstar.
                  </mds-checkbox>
                </div>

                <div class="billing-address-popover">
                  <a
                    type="button"
                    @click="toggle = !toggle"
                    id="default-trigger"
                    class="popover-billing-address"
                    >Why do we need it?</a
                  >
                </div>

                <mds-popover
                  size="small"
                  :position="['top-right']"
                  class="billingaddress-popover"
                  triggered-by="default-trigger"
                  v-model="toggle"
                >
                  We use your phone number for Morningstar-related matters. Morningstar
                  does not share this contact information without your separate consent.
                  See our Privacy Policy for complete details.
                </mds-popover>
              </div>
              <div class="billingaddress-registration-button-container">
                <div>
                  <mds-button-container left-aligned>
                    <!-- Icon On Left -->
                    <mds-button
                      variation="secondary"
                      size="large"
                      @click="
                        $router.push({
                          name: 'subscription',
                          params: {
                            productcode: $route.params.productcode,
                          },
                          query: { offerCode: $route.query.offerCode }
                        })
                      "
                    >
                      Back
                    </mds-button>
                    <div class="billing-address-cancel-button">
                      <mds-button
                        variation="secondary"
                        size="large"
                        type="button"
                        @click="
                          $router.push({
                            name: 'combined-home',
                            params: { currentproduct: 'Common' },
                          })
                        "
                      >
                        Cancel
                      </mds-button>
                    </div>
                    <div class="billing-address-continue-button">
                      <!-- Icon On Both Sides -->
                      <mds-button
                        variation="primary"
                        size="large"
                        class="continue-button"
                        type="button"
                        right-aligned
                        @click="ContinueForm"
                        :disabled="isLoading"
                      >
                        Continue
                      </mds-button>
                    </div>
                  </mds-button-container>
                </div>
              </div>
              <div class="billingaddress-register-page-bottom"></div>
            </div>
          </div>
        </div>
      </div>
    </mds-page-shell>
  </div>
</template>

<script>
import MdsInput from "@mds/input";
import MdsCheckbox from "@mds/checkbox";
import { MdsButton, MdsButtonContainer } from "@mds/button";
import MdsSelect from "@mds/select";
import MdsPopover from "@mds/popover";
import MdsPageShell from "@mds/page-shell";
import MdsLoader from "@mds/loader";
import EncryptDecryptMixin from "../../mixins/EncryptDecryptMixin";
import { fetchData, postData } from "@/utilities/API/apiUtility";
import MdsAlert from "@mds/alert";
import { getCustomerFromStripe, getUserDetailsFromStripe } from '@/utilities/stripe';
import { GetSessionData } from "@/utilities/userDataUtility";
export default {
  name: "billing-address-section",
  mixins: [EncryptDecryptMixin],
  components: {
    MdsInput,
    MdsAlert,
    MdsCheckbox,
    MdsButton,
    MdsButtonContainer,
    MdsSelect,
    MdsPopover,
    MdsPageShell,
    MdsLoader,
  },
  data() {
    return {
      mobileAlerts: false,
      liststripeCountry: this.$store.state.country.stripeCountryList,
      listCanadaState: this.$store.state.country.Canadastateslist,
      listUSAState: this.$store.state.country.USAstateslist,
      listphoneType: this.$store.state.country.phoneType,

      isMobileChecked: true,
      toggle: false,
      checked: false,
      cityError: false,
      addressError: false,
      CountryError: false,
      stateError: false,
      //CanadastateError: false,
      zipcodeError: false,
      phonetypeError: false,
      phonenumberError: false,

      Canadastate: "",
      USAstate: "",
      stateprovince: "",

      zipcode: "",
      phonenumber: "",
      DPhone: "",
      MPhone: "",
      phonetype: "Mobile Phone",
      country: "",
      address: "",
      city: "",
      productCode: this.$route.params.productcode,

      isLoading: true,

      stateLable: "State/Province/APO",
      zipLable: "Zip Code",

      isStateUSA: false,
      isStateCanada: false,
      isNotUSACanadaState: false,

      stateErrorMessage: null,
      phoneErrorMessage: null,
      zipcodeErrorMessage: null,

      userDetails: [],
      isResponsive: null,
      userID: null,
      termETFAnnual: this.$route.params.termETFAnnual,
      termMFIAnnual: this.$route.params.termMFIAnnual,
      termMDIAnnual: this.$route.params.termMDIAnnual,
      termMSIAnnual: this.$route.params.termMSIAnnual,
      termETFQuarterly: this.$route.params.termETFQuarterly,
      termMFIQuarterly: this.$route.params.termMFIQuarterly,
      termMDIQuarterly: this.$route.params.termMDIQuarterly,
      termMSIQuarterly: this.$route.params.termMSIQuarterly,
      productNameETFQuarterly: this.$route.params.productNameETFQuarterly,
      productNameMFIQuarterly: this.$route.params.productNameMFIQuarterly,
      productNameMSIQuarterly: this.$route.params.productNameMSIQuarterly,
      productNameMDIQuarterly: this.$route.params.productNameMDIQuarterly,
      productNameETFAnnual: this.$route.params.productNameETFAnnual,
      productNameMFIAnnual: this.$route.params.productNameMFIAnnual,
      productNameMSIAnnual: this.$route.params.productNameMSIAnnual,
      productNameMDIAnnual: this.$route.params.productNameMDIAnnual,
      ValidateAddressAndCalculateTax:
        process.env.VUE_APP_BackEndAPI +
        process.env.VUE_APP_ValidateAddressAndCalculateTax,
      taxAmountForMSI: "",
      taxAmountForMFI: "",
      taxAmountForMDI: "",
      taxAmountForMEI: "",
      isValidAddress: true,
      isValidAddressForCreatingUserInstripe: false,
      updatedphonetype: "",
      isZipCodeRequired: false,
      isLoggedIn:false,
    };
  },
  
  async mounted() {
    //This is just to pre-populate the dropdowns until details are fetch.
    this.country = "US";
    this.isStateUSA = true;
    this.isZipCodeRequired = true;
    ///////////////////////
    
    window.scrollTo(0, 0);
    this.isLoggedIn = this.$store.state.user.LoggedIn
    if (this.isLoggedIn) {
      this.userID = this.$auth0.user["https://morningstar.com/mstar_id"];
    }
    this.$store.state.layout.isHeaderRequired = false;
    this.$store.state.layout.isFooterRequired = false;
    await this.fetchCustomerDetailsFromStripe();
    await this.populateForm();
    this.isLoading = false;
  },
  created() {
    window.addEventListener("resize", this.checkViewPortSize);
    this.checkViewPortSize();
  },
  methods: {
    CloseAlertBox() {
      this.isValidAddress = true;
    },

    ChangeCountryName(name) {
      if (!name) return "";

      const nameToUpperCase = name.toUpperCase();

      if (nameToUpperCase === "USA" || nameToUpperCase === "US") {
        return nameToUpperCase;
      }

      return name
        .toLowerCase()
        .split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
    checkViewPortSize() {
      this.viewPortWidth = window.innerWidth;
      if (this.viewPortWidth < 600) {
        this.isResponsive = true;
      } else {
        this.isResponsive = false;
      }
    },
    getProductLogo() {
      var images = require.context("../../../assets/Images", false, /\.svg$/);
      return images("./Common.svg");
    },
    // saveDataToSessionStorage(data) {
    //   data = JSON.stringify(data);
    //   data = this.Encrypt(data);
    //   localStorage.setItem("u9", data); //u9 means its userDetails [ for security purpose I have used pseudo name and not evident name]
    // },
    async fetchCustomerDetailsFromStripe() {
      try {
        if (!this.userID) {
          // const encryptedData = localStorage.getItem("u9");
          // if (!encryptedData) return;

          // const decryptedData = this.Decrypt(encryptedData);
          // if (!decryptedData) return;

          // const parsedData = JSON.parse(decryptedData);
          const sessionData = await GetSessionData(this.$session);
          this.userID = sessionData.UIMId;
          if (!this.userID) return;
        }
        if(this.isLoggedIn){
          this.userDetails = await getUserDetailsFromStripe('newsletters',this.userID);
         // Retry fetching from localStorage customerID if userDetails is missing for a logged-in user
          const sessionData = await GetSessionData(this.$session);
          const customerID = sessionData.StripeCustId;
          //const customerID = localStorage.getItem("c42");
          if (!this.userDetails && customerID) {
              this.userDetails = await getCustomerFromStripe(customerID);
          }
        }else{
          const sessionData = await GetSessionData(this.$session);
          const customerID = sessionData.StripeCustId;
          this.userDetails = await getCustomerFromStripe(customerID);
        }
      } catch (error) {
          console.error('Error fetching user details from Stripe:', error);
      }
    },
  
    async populateForm() {
      if (!this.userDetails) return;

      const address = this.userDetails.address || {};
      const metadata = this.userDetails.metadata || {};

      if (address.country) {
        const country = address.country.toLowerCase();
        this.country = address.country.toUpperCase();
        this.address = address.line1;
        this.city = address.city;
        this.zipcode = address.postalCode;

        // Reset state flags
        this.isZipCodeRequired = false;
        this.isStateCanada = false;
        this.isStateUSA = false;
        this.isNotUSACanadaState = false;

        switch (country) {
          case "usa":
          case "us":
            this.isStateUSA = true;
            this.USAstate = address.state;
            this.isZipCodeRequired = true;
            break;

          case "canada":
          case "ca":
            this.isStateCanada = true;
            this.Canadastate = address.state;
            this.zipLable = "Zip / Postal Code";
            break;

          default:
            this.isNotUSACanadaState = true;
            this.stateprovince = address.state;
            this.zipLable = "Zip / Postal Code";
            break;
        }

        // Phone setup
        const isMobile = this.userDetails.mobilePhone != null ? true : false;
        this.phonetype = isMobile ? "Mobile Phone" : "Home Phone";
        this.phonenumber = isMobile ? this.userDetails.mobilePhone : metadata.home_phone;
        this.isMobileChecked = isMobile;
      } else {
        this.country = "US";
        this.isStateUSA = true;
      }
      try {
        if (this.$store.state.user.LoggedIn) {
          if (this.userConsents == null || this.userConsents == undefined || this.userConsents.Ids == undefined) {
            await this.GetUserConsents(this.userID);
          }
        } else {
          let savedconsents = this.Decrypt(localStorage.getItem("userConsents"));
          if (savedconsents) {
            savedconsents = JSON.parse(savedconsents);
            this.userConsents = savedconsents.UserConsents;
          }
        }
        if (this.userConsents != null && this.userConsents != undefined && this.userConsents.Ids != undefined && this.userConsents.Ids.includes("mobile-alerts-opt-in")) {
          this.mobileAlerts = true;
        }
      } catch (error) {
        if (process.env.NODE_ENV == 'development') {
          console.error("Error in populateForm:", error);
        }
      }
    },
    onChangeCountry(country) {
      const lowerCountry = country.toLowerCase();
      this.zipcodeError = false;
      this.stateError = false;

      // Reset common values
      this.isStateUSA = false;
      this.isStateCanada = false;
      this.isNotUSACanadaState = false;

      if (lowerCountry === "usa" || country === "US") {
        this.USAstate = "";
        this.isStateUSA = true;
        this.stateLable = "State";
        this.zipLable = "Zip Code";
        this.isZipCodeRequired = true;
      } else if (lowerCountry === "canada" || country === "CA") {
        this.Canadastate = "";
        this.isStateCanada = true;
        this.stateLable = "Province";
        this.zipLable = "Zip / Postal Code";
        this.isZipCodeRequired = false;
      } else {
        this.stateprovince = "";
        this.isNotUSACanadaState = true;
        this.stateLable = "State/Province/APO";
        this.zipLable = "Zip / Postal Code";
        this.isZipCodeRequired = false;
      }
    },
    changePhoneType() {
      this.phonenumber = "";
      if (this.phonetype === "Home Phone") {
        this.isMobileChecked = false;
      } else {
        this.isMobileChecked = true;
      }
    },
    setProductTaxInLocalStorage(data, productSubscriptionTaxAmount) {
      localStorage.setItem(productSubscriptionTaxAmount, JSON.stringify(data));
    },
    async GetUserConsents(UserId) {      
      var GetUserConsentsUrl =
        process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_GetUserConsents;
      GetUserConsentsUrl = GetUserConsentsUrl.replace(
        "{userId}",
        UserId.toUpperCase()
      );
      try {
        const response = await fetchData(GetUserConsentsUrl);

        if (response && response.status == 200) {
          this.userConsents = response.data;
          this.saveUserConsentsTolocalStorage({ UserConsents: this.userConsents });
        }
      }  catch (error) {
        if (process.env.NODE_ENV == 'development') {
          console.log("Error in GetUserConsents:", error);
        }
      }      
    },
    async UpdateUserConsents(UserId, MobileConsent) {
      let updateUserConsents = false;
      this.isLoading = true;      

      try {        
        if (this.userConsents == null || this.userConsents == undefined) {
          if (MobileConsent === true) {
            updateUserConsents = true;
            this.userConsents = {};  // Initialize as an object, not an array
            this.userConsents.user = UserId;
            this.userConsents.Ids = [];  // Initialize Ids as an empty array
            this.userConsents.Ids.push("mobile-alerts-opt-in");
          }
        }
        else {
          if (MobileConsent === true && !this.userConsents.Ids.includes("mobile-alerts-opt-in")) {
            updateUserConsents = true;
            this.userConsents.Ids.push("mobile-alerts-opt-in");
          } else if (MobileConsent === false && this.userConsents.Ids.includes("mobile-alerts-opt-in")) {
            updateUserConsents = true;
            const indexToRemove = this.userConsents.Ids.indexOf("mobile-alerts-opt-in");
            if (indexToRemove !== -1) {
              this.userConsents.Ids.splice(indexToRemove, 1);
            }
          }
        }

        if (updateUserConsents == true) {
          var AddUpdateUserConsentsUrl = process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_AddUpdateUserConsents;

          const postResponse = await postData(AddUpdateUserConsentsUrl, this.userConsents);

          if (!postResponse || postResponse.status !== 200) {
            //except console nothing was here so kept it for dev env
            if (process.env.NODE_ENV == 'development') {
              console.log("Error updating consents");
            }
          } else {
            this.saveUserConsentsTolocalStorage({ UserConsents: this.userConsents });
          }
        }
        
      } catch (error) {
        if (process.env.NODE_ENV == 'development') {
          console.log("Error in UpdateUserConsents:", error);
        }
      }
    },
    saveUserConsentsTolocalStorage(data) {
      data = JSON.stringify(data);
      data = this.Encrypt(data);
      localStorage.setItem("userConsents", data);
    },
    async ContinueForm() {
      if (
        this.cityError == false &&
        this.addressError == false &&
        this.CountryError == false &&
        this.stateError == false &&
        this.zipcodeError == false &&
        this.phonetypeError == false &&
        this.phonenumberError == false
      ) {
        this.isLoading = true;
      }


      if (this.country == null || this.country == "") {
        this.CountryError = true;
        this.isValidAddress = true;
      }

      if (this.address == null || this.address == "") {
        this.addressError = true;
        this.isValidAddress = true;
      }

      if (this.city == null || this.city == "") {
        this.cityError = true;
        this.isValidAddress = true;
      }

      if (this.country.toLowerCase() == "usa" || this.country == "US") {
        if (this.USAstate == null || this.USAstate == "") {
          this.stateError = true;
          this.isValidAddress = true;
        }
      }
      if (this.country == "CA" || this.country == "Canada") {
        if (this.Canadastate == null || this.Canadastate == "") {
          this.isValidAddress = true;
        }
      }

      if (this.country.toLowerCase() === "usa" || this.country === "US") {
        // USA zip code validation
        if (!this.zipcode || !/^\d{5}(?:[-\s]\d{4})?$/.test(this.zipcode)) {
          this.zipcodeError = true;
          this.isValidAddress = true;
          this.zipcodeErrorMessage = this.zipcode
            ? "Zip code is not valid"
            : "Please enter Zipcode";
        } else {
          this.zipcodeError = false;
          this.isValidAddress = true;
        }
      } else {
        // Other countries: Ensure that a zip code is entered
        if (!this.zipcode) {
          this.zipcodeError = false;
        } else {
          this.zipcodeError = false;
        }
      }

      if (this.phonenumber == null || this.phonenumber == "") {
        this.phonenumberError = true;
        this.isValidAddress = true;
        this.phoneErrorMessage = "Please enter Phone number";
      } else if (
        !/^\+?(\d[\d-. ]+)?(\([\d-. ]+\))?[\d-. ]+\d$/.test(this.phonenumber) ||
        this.phonenumber.length < 10 || this.phonenumber.length > 20
      ) {
        this.phonenumberError = true;
        this.isValidAddress = true;
        this.phoneErrorMessage = " Phone number is not valid";
      } else {
        this.phonenumberError = false;
      }

      const getSubscriptionData = (key) => {
        const encryptedData = localStorage.getItem(key);
        if (!encryptedData) return;

        const decryptedData = this.Decrypt(encryptedData);
        if (!decryptedData) return;

        return decryptedData ? JSON.parse(decryptedData) : null;
      }

      if (
        !this.CountryError &&
        !this.addressError &&
        !this.cityError &&
        !this.stateError &&
        !this.zipcodeError &&
        !this.phonenumberError
      ) {
        var selectedstate = "";

        if (this.country.toLowerCase() == "usa" || this.country == "US")
          selectedstate = this.USAstate;
        else if (this.country == "CA" || this.country == "Canada")
          selectedstate = this.Canadastate;
        else selectedstate = this.stateprovince;

        if (this.phonetype == "Mobile Phone") {
          this.MPhone = this.phonenumber;
          this.isMobileChecked = true;

          //This condition : When the user has both phone numbers 
          this.DPhone = this.userDetails.metadata.home_phone ? this.userDetails.metadata.home_phone :"";
        } else {
          this.DPhone = this.phonenumber;
          this.isMobileChecked = false;

          //This condition : When the user has both phone numbers 
          this.MPhone = this.userDetails.mobilePhone ? this.userDetails.mobilePhone :"";
        }

        if (this.userDetails != null) {
          await this.UpdateUserConsents(this.userID, this.mobileAlerts);
        }

        if ((this.productNameETFAnnual != null) & (this.termETFAnnual != null)) {
          this.$gtag.event("create_user_profile", {
            product: "MEI",
            term: "Annual Digital",
            userid: this.userID,
          });
        }
        if (
          (this.productNameETFQuarterly != null) &
          (this.productNameETFQuarterly != null)
        ) {
          this.$gtag.event("create_user_profile", {
            product: "MEI",
            term: "Quarterly Digital",
            userid: this.userID,
          });
        }
        if ((this.productNameMFIAnnual != null) & (this.termMFIAnnual != null)) {
          this.$gtag.event("create_user_profile", {
            product: "MFI",
            term: "Annual Digital",
            userid: this.userID,
          });
        }
        if (
          (this.productNameMFIQuarterly != null) &
          (this.productNameMFIQuarterly != null)
        ) {
          this.$gtag.event("create_user_profile", {
            product: "MFI",
            term: "Quarterly Digital",
            userid: this.userID,
          });
        }
        if ((this.productNameMDIAnnual != null) & (this.termMDIAnnual != null)) {
          this.$gtag.event("create_user_profile", {
            product: "MDI",
            term: "Annual Digital",
            userid: this.userID,
          });
        }
        if (
          (this.productNameMDIQuarterly != null) &
          (this.productNameMDIQuarterly != null)
        ) {
          this.$gtag.event("create_user_profile", {
            product: "MDI",
            term: "Quarterly Digital",
            userid: this.userID,
          });
        }
        if ((this.productNameMSIAnnual != null) & (this.termMSIAnnual != null)) {
          this.$gtag.event("create_user_profile", {
            product: "MSI",
            term: "Annual Digital",
            userid: this.userID,
          });
        }
        if (
          (this.productNameMSIQuarterly != null) &
          (this.productNameMSIQuarterly != null)
        ) {
          this.$gtag.event("create_user_profile", {
            product: "MSI",
            term: "Quarterly Digital",
            userid: this.userID,
          });
        }

        // Helper function to safely get and parse subscription data

        // Retrieve data from localStorage
        this.MEIsubscrptionData = getSubscriptionData("MEIProductSubscription");
        this.MSIsubscrptionData = getSubscriptionData("MSIProductSubscription");
        this.MDIsubscrptionData = getSubscriptionData("MDIProductSubscription");
        this.MFIsubscrptionData = getSubscriptionData("MFIProductSubscription");


        // Safely extract the price (if data exists) and default to 0 if price is not available
        let MSIPrice =
          this.MSIsubscrptionData && this.MSIsubscrptionData.Price
            ? this.MSIsubscrptionData.Price
            : 0;
        let MDIPrice =
          this.MDIsubscrptionData && this.MDIsubscrptionData.Price
            ? this.MDIsubscrptionData.Price
            : 0;
        let MFIPrice =
          this.MFIsubscrptionData && this.MFIsubscrptionData.Price
            ? this.MFIsubscrptionData.Price
            : 0;
        let MEIPrice =
          this.MEIsubscrptionData && this.MEIsubscrptionData.Price
            ? this.MEIsubscrptionData.Price
            : 0;

        // Calculate tax for each subscription
        let taxMSI, taxMDI, taxMFI, taxMEI;

        if (this.country == "USA" || this.country == "US") {
          // Prepare the API URL
          let Url = this.ValidateAddressAndCalculateTax;

          // Replace placeholder values in the URL
          Url = Url.replace("{city}", this.city);
          Url = Url.replace("{region}", selectedstate)
          Url = Url.replace("{customid}", this.userDetails.id); // Stripe Customer ID
          Url = Url.replace(
            "{buyername}",
            this.userDetails.metadata.mstar_fname + " " + this.userDetails.metadata.mstar_lname
          );
          Url = Url.replace("{postalcode}", this.zipcode);
          Url = Url.replace("{streetname}", encodeURIComponent(this.address));
          Url = Url.replace("{currencycode}", "USD");
          Url = Url.replace("{billingcountrycode}", "US");
          
          // Loop through the subscription types and calculate tax for each
          const calculateTax = async (price, subscriptionType) => {
            let taxUrl = Url.replace("{amount}", price);
            try {
              const response = await postData(taxUrl);
              if (response && response.status == 200 && response.data) {
                let taxAmount = response.data.TaxAmount;

                let responseMessage = response.data.ResponseMessage;

                if (
                  responseMessage ==
                  "The entered Address is Wrong, please add a valid address!"
                ) {
                  this.isValidAddress = false;
                } else if (responseMessage == "Tax calculation successful") {
                  this.isValidAddress = true;
                  this.isValidAddressForCreatingUserInstripe = true;
                }

                switch (subscriptionType) {
                  case "MSI": {
                    const taxMSI = taxAmount;
                    this.taxAmountForMSI = taxMSI;

                    const msiCalculatedTaxAmount = {
                      taxamount: this.taxAmountForMSI,
                    };

                    this.setProductTaxInLocalStorage(
                      msiCalculatedTaxAmount,
                      "MSITaxAmount"
                    );

                    break;
                  }

                  case "MDI": {
                    const taxMDI = taxAmount; // Declare taxMDI properly
                    this.taxAmountForMDI = taxMDI;
                    const mdiCalculatedTaxAmount = {
                      taxamount: this.taxAmountForMDI,
                    };

                    // Fix the typo in the localStorage key
                    this.setProductTaxInLocalStorage(
                      mdiCalculatedTaxAmount,
                      "MDITaxAmount"
                    );

                    break;
                  }

                  case "MFI": {
                    const taxMFI = taxAmount; // Declare taxMFI properly
                    this.taxAmountForMFI = taxMFI;
                    const mfiCalculatedTaxAmount = {
                      taxamount: this.taxAmountForMFI,
                    };

                    // Fix the typo in the localStorage key
                    this.setProductTaxInLocalStorage(
                      mfiCalculatedTaxAmount,
                      "MFITaxAmount"
                    );

                    break;
                  }

                  case "MEI": {
                    const taxMEI = taxAmount; // Declare taxMEI properly
                    this.taxAmountForMEI = taxMEI;
                    const meiCalculatedTaxAmount = {
                      taxamount: this.taxAmountForMEI,
                    };

                    // Fix the typo in the localStorage key
                    this.setProductTaxInLocalStorage(
                      meiCalculatedTaxAmount,
                      "MEITaxAmount"
                    );

                    break;
                  }

                  default:
                    break;
                }
              }
              else{
                this.isValidAddress = false;
              }
            } catch (error) {
              if (process.env.NODE_ENV == 'development') {
                console.error(`Error calculating tax for ${subscriptionType}:`, error);
                console.log("Taxes : " + taxMDI + taxMEI + taxMFI + taxMSI);
              }
              this.isValidAddress = false;
            }
          };

          // Calculate tax for each subscription
          await calculateTax(MSIPrice, "MSI");
          await calculateTax(MDIPrice, "MDI");
          await calculateTax(MFIPrice, "MFI");
          await calculateTax(MEIPrice, "MEI");
        } else if (this.country != "USA" || this.country != "US") {
          // Prepare the API URL
          let Url = this.ValidateAddressAndCalculateTax;

          if (this.zipcode == "") {
            this.zipcode = "-";
          }

          // Replace placeholder values in the URL
          Url = Url.replace("{city}", this.city);
          Url = Url.replace("{region}", this.State);
          Url = Url.replace("{customid}", this.userDetails.id); // Stripe customer ID
          Url = Url.replace(
            "{buyername}",
            this.userDetails.metadata.mstar_fname + " " + this.userDetails.metadata.mstar_lname
          );
          Url = Url.replace("{postalcode}", this.zipcode);
          Url = Url.replace("{streetname}", this.address);
          Url = Url.replace("{currencycode}", "EUR");
          Url = Url.replace("{billingcountrycode}", "BE");

          // Loop through the subscription types and calculate tax for each
          const calculateTax = async (price, subscriptionType) => {
            let taxUrl = Url.replace("{amount}", price);
            try {
              const response = await postData(taxUrl);
              if (response && response.status == 200 && response.data) {
                let taxAmount = response.data.TaxAmount;
                let responseMessage = response.data.ResponseMessage;
                this.taxAmountForMSI = "0";
                this.taxAmountForMEI = "0";
                this.taxAmountForMDI = "0";
                this.taxAmountForMFI = "0";
                if (
                  responseMessage ==
                  "The entered Address is Wrong, please add a valid address!"
                ) {
                  this.isValidAddress = false;
                } else if (
                  responseMessage == "Tax calculation successful" ||
                  responseMessage == "Currency is not USD, tax amount is 0"
                ) {
                  this.isValidAddress = true;
                  this.isValidAddressForCreatingUserInstripe = true;
                }
                switch (subscriptionType) {
                  case "MSI": {
                    const taxMSI = taxAmount; // Declare taxMSI properly
                    this.taxAmountForMSI = taxMSI;

                    const msiCalculatedTaxAmount = {
                      taxamount: this.taxAmountForMSI,
                    };

                    // Fix the typo in the localStorage key
                    this.setProductTaxInLocalStorage(
                      msiCalculatedTaxAmount,
                      "MSITaxAmount"
                    );

                    break;
                  }

                  case "MDI": {
                    const taxMDI = taxAmount; // Declare taxMDI properly
                    this.taxAmountForMDI = taxMDI;
                    const mdiCalculatedTaxAmount = {
                      taxamount: this.taxAmountForMDI,
                    };

                    // Fix the typo in the localStorage key
                    this.setProductTaxInLocalStorage(
                      mdiCalculatedTaxAmount,
                      "MDITaxAmount"
                    );

                    break;
                  }

                  case "MFI": {
                    const taxMFI = taxAmount; // Declare taxMFI properly
                    this.taxAmountForMFI = taxMFI;
                    const mfiCalculatedTaxAmount = {
                      taxamount: this.taxAmountForMFI,
                    };

                    // Fix the typo in the localStorage key
                    this.setProductTaxInLocalStorage(
                      mfiCalculatedTaxAmount,
                      "MFITaxAmount"
                    );

                    break;
                  }

                  case "MEI": {
                    const taxMEI = taxAmount; // Declare taxMEI properly
                    this.taxAmountForMEI = taxMEI;
                    const meiCalculatedTaxAmount = {
                      taxamount: this.taxAmountForMEI,
                    };

                    // Fix the typo in the localStorage key
                    this.setProductTaxInLocalStorage(
                      meiCalculatedTaxAmount,
                      "MEITaxAmount"
                    );

                    break;
                  }

                  default:
                    break;
                }
              } else if (response.status == 400) {
                this.isValidAddress = false;
              }
            } catch (error) {
              if (process.env.NODE_ENV == 'development') {
                console.error(`Error calculating tax for ${subscriptionType}:`, error);
              }
              this.isValidAddress = false;
            }
          };

          // Calculate tax for each subscription
          await calculateTax(MSIPrice, "MSI");
          await calculateTax(MDIPrice, "MDI");
          await calculateTax(MFIPrice, "MFI");
          await calculateTax(MEIPrice, "MEI");
        }

        // Proceed to the next step or API call depending on the tax calculation results
        await this.updateUserDetails();
      }
      this.isLoading = false;
    },
    async updateUserDetails() {
      var selectedstate = "";
      if (this.country.toLowerCase() == "usa" || this.country == "US")
        selectedstate = this.USAstate;
      else if (this.country == "CA" || this.country == "Canada")
        selectedstate = this.Canadastate;
      else selectedstate = this.stateprovince;
      try {
        if (this.MPhone && this.MPhone.trim() !== "" && this.DPhone == "") {
          // If MPhone has a value (not empty), set phonetype to "mobile"
          this.updatedphonetype = "mobile";
        } else {
          this.updatedphonetype = "";
        }

        if (
          this.taxAmountForMFI !== null &&
          this.taxAmountForMFI !== undefined ||
          this.taxAmountForMSI !== null &&
          this.taxAmountForMSI !== undefined ||
          this.taxAmountForMDI !== null &&
          this.taxAmountForMDI !== undefined ||
          this.taxAmountForMEI !== null &&
          this.taxAmountForMEI !== undefined
        ) {
          // If the address is valid, Create the user in Stripe
          if (
            this.isValidAddressForCreatingUserInstripe == true
          ) {
            var finalCountryForUpdate;
            const countryName = this.country.trim().toLowerCase();

            if (countryName === "usa") {
              finalCountryForUpdate = "US";
            } else {
              const matchingCountries = this.$store.state.country.stripeCountryList.filter(
                (item) => {
                  // Case insensitive comparison of country names
                  return item.Country.toLowerCase() === countryName;
                }
              );

              if (matchingCountries.length > 0) {
                finalCountryForUpdate = matchingCountries[0].CountryCode;
              } else {
                finalCountryForUpdate = this.country;
              }
            }

            await this.updateCustomerInStripe(finalCountryForUpdate, selectedstate);
          }
        }
      } catch (error) {
        if (process.env.NODE_ENV == 'development') {
          console.log("Error calling API:", error);
        }
      }
    },
    async updateCustomerInStripe(country, state) {
      var UpdateUserCommand = this.updateStripeCustomerPayload(country, state);
      const response = await postData(
        process.env.VUE_APP_BackEndAPI +
        process.env.VUE_APP_UpdateStripeUserDetails,
        UpdateUserCommand
      );

      if (response) {
        if (response.status == 200) {
          if (response.data != null && response.data !== "") {
            this.pushToAutoRenewPage();
          }
        }
      }
    },
    updateStripeCustomerPayload(country, state) {
      const UpdateUserCommand = {
        customerId: this.userDetails.id,
        country: country,
        phone: this.MPhone,
        addressLine1: this.address,
        city: this.city,
        state: state,
        postalCode: this.zipcode,
        metadata: {
          phone_type: this.updatedphonetype,
          home_phone: this.DPhone,
        },
      };
      return UpdateUserCommand;
    },
    pushToAutoRenewPage(){
      this.$router
        .push({
          name: "autorenew",
          params: {
            productcode: this.$route.params.productcode,
          },
          query: { offerCode: this.$route.query.offerCode }
        })
        .catch((err) => {
          if (
            err.name !== "NavigationDuplicated" &&
            !err.message.includes(
              "Avoided redundant navigation to current location"
            )
          ) {
            console.log(err);
          }
      });
    }
  },
  watch: {
    USAstate(newVal, oldVal) {
      if (newVal != oldVal) {
        if (newVal != null && newVal != "") {
          this.stateError = false;
        } else {
          this.stateError = true;
        }
      }
    },

    address(newVal, oldVal) {
      if (newVal != oldVal) {
        if (newVal == null || newVal == "") {
          this.addressError = true;
        } else {
          this.addressError = false;
        }
      }
    },

    country(newVal, oldVal) {
      if (newVal != oldVal) {
        if (newVal == null || newVal == "") {
          this.CountryError = true;
        } else {
          this.CountryError = false;
        }
      }
    },

    city(newVal, oldVal) {
      if (newVal != oldVal) {
        if (newVal == null || newVal == "") {
          this.cityError = true;
        } else {
          this.cityError = false;
        }
      }
    },
    zipcode(newVal, oldVal) {
      if (newVal !== oldVal) {
        if((this.country != null || this.country != ""))
        if (this.country.toLowerCase() === "usa" || this.country.toLowerCase() === "US") {
          if (!newVal || !/^\d{5}(?:[-\s]\d{4})?$/.test(newVal)) {
            this.zipcodeError = true;
            this.zipcodeErrorMessage = newVal
              ? "Zip code is not valid"
              : "Please enter Zipcode";
          } else {
            this.zipcodeError = false;
          }
        }
      } else {
        this.zipcodeError = false;
      }
    },
    phonenumber(newVal, oldVal) {
      if (newVal != oldVal) {
        if (newVal != null && newVal != "") {
          if (
            !/^\+?(\d[\d-. ]+)?(\([\d-. ]+\))?[\d-. ]+\d$/.test(this.phonenumber) ||
            this.phonenumber.length < 10 || this.phonenumber.length > 20
          ) {
            this.phonenumberError = true;
            this.phoneErrorMessage = " Phone number is not valid";
          } else {
            this.phonenumberError = false;
          }
        }
      }

      if (this.phonenumber != null && this.phonenumber != "") {
        if (
          !/^\+?(\d[\d-. ]+)?(\([\d-. ]+\))?[\d-. ]+\d$/.test(this.phonenumber) ||
          this.phonenumber.length < 10 || this.phonenumber.length > 20
        ) {
          this.phoneErrorMessage = " Phone number is not valid";
        } else {
          this.phonenumberError = false;
        }
      }
    },
    phonetype(newVal, oldVal) {
      if (newVal !== oldVal) {
      const isMobile = newVal.toLowerCase() === "mobile phone";
      this.isMobileChecked = isMobile;

      if (isMobile) {
        this.phonenumber = this.userDetails.mobilePhone ?? "";
      } else {
        const homePhone = this.userDetails.metadata.home_phone;
        this.phonenumber = homePhone ? homePhone : "";
      }
    }
  },
  },
};
</script>

<style scoped>
.billingaddress-loader {
  z-index: 9999; /* Ensure the loader is on top of other content */
  position: absolute; /* Absolute positioning to place it within the parent */
  top: 50%; /* Centers the loader vertically */
  left: 50%; /* Centers the loader horizontally */
  transform: translate(-50%, -50%); /* Adjust to truly center the loader */
}

.billing-address-invalid {
  height: 170px;

  margin-bottom: 9px;
}

.billingaddress-registration-form-billing-address-container {
  width: 380px;
  margin: 0 auto;
}

.billing-address-continue-button {
  margin-left: 10px;
  order: 2;
}

.billing-address-cancel-button {
  margin-left: 65px;
}

.billingaddress-register-page-bottom {
  background: linear-gradient(360deg, #ffffff 12.47%, rgba(255, 255, 255, 0) 112.75%);
  opacity: 1;
  z-index: 2;
  transform: rotate(180deg);
  height: 50px;
}

.billing-address-main {
  height: 100%;
  min-height: 100vh;
  background: #f2f2f2;
}

.billingaddress-registration-form-billing-address {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  background-color: #fff;
  height: 100%;
  min-height: 100vh;
}

.billing-address-page-title {
  margin-bottom: 65px;
  height: 44px;
  padding-top: 57px;
  font-weight: 250;
  font-size: 28px;
  line-height: 34px;
}

.billing-address-form-title {
  width: 100%;
}

.billing-address-form-fields {
  position: relative;
  width: 100%;
}

.billing-address-checkboxes {
  margin-top: 5%;
  width: 100%;
}

.billingaddress-registration-button-container {
  height: 48px;
  margin-top: 8%;
  width: 100%;
}

.horizonatal-fieldset {
  display: flex;
}

.fieldset-first {
  width: 36.5%;
  flex-basis: 48%;
}

.fieldset-second {
  width: 37%;
  margin-left: auto;
  flex-basis: 48%;
}

.billing-address-popover {
  margin-left: 6%;
  margin-top: 1%;
}

.popover-billing-address {
  cursor: pointer;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  color: #5e5e5e;
}

.popover:content {
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #1e1e1e;
}

.FormsError {
  font-size: 16px;
  font-weight: 300;
  line-height: 21px;
  color: #ca0000;
  display: block;
  margin-top: 2%;
}

@media only screen and (max-width: 480px) {
  .billingaddress-registration-form-billing-address-container {
    width: 90%;
    margin: 0 auto;
  }
  .billing-address-page-title {
    padding-top: 28px;
    margin-bottom: 15%;
  }
  .billing-address-form-fields {
    margin-top: 10%;
  }
}
</style>
<style>
.billing-address-main .mds-label.mds-label--large .mds-label__text {
  font-size: 16px !important;
  font-weight: 300 !important;
  line-height: 21px !important;
  font-weight: 700 !important;
  margin-bottom: 2% !important;
}
.billing-address-checkboxes .mds-checkbox__visible-wrap {
  box-shadow: none !important;
}

.billingaddress-popover {
  margin-left: 23%;
  top: 685px;
  left: 1220px;
}

.billing-address-invalid > div {
  padding-top: 13px;
  width: 380px;
  height: 170px;
}

.billing-address-invalid > div > div:nth-child(2) > div {
  width: 280px;
  padding-right: 0px;
}

.billing-address-invalid > div > div:nth-child(2) {
  padding-right: 0px !important;
}

.billing-address-invalid > div > button {
  margin-top: 10px;
  margin-right: -5px;
}
</style>
